import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["hidden"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'InputPortal',
    props: {
        target: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                hidden: __props.target === undefined,
                "data-input-fallback": ""
            }, [
                (_openBlock(), _createBlock(_Teleport, {
                    to: __props.target,
                    disabled: __props.target === undefined
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 8, ["to", "disabled"]))
            ], 8, _hoisted_1));
        };
    }
});
